<div class="row">
  <div class="col">
    <div class="card">
      <div *ngIf="displayHeader" class="card-header">
        <h1>{{ pageTitle }}</h1>
      </div>
      <div class="card-body">
        <h2>{{ 'change_password' | translate }}</h2>
        <app-change-password *ngIf="isNotUsingExternalIdp"></app-change-password>
        <app-deactivate-account></app-deactivate-account>
      </div>
    </div>
  </div>
</div>
